// extracted by mini-css-extract-plugin
export var label = "_e7-2";
export var slideContainer = "_e7-0";
export var slider = "_e7-1";